import axios from '../utils/axios';

// 用户登录
export const login = (username, password) => {
  return axios.post('/api/auth/login', { username, password });
};

// 获取当前用户信息
export const getCurrentUser = () => {
  return axios.get('/api/auth/current-user');
};

// 检查用户是否已登录
export const isLoggedIn = () => {
  return localStorage.getItem('token') !== null;
};

// 获取用户token
export const getToken = () => {
  return localStorage.getItem('token');
};

// 保存用户token
export const saveToken = (token) => {
  localStorage.setItem('token', token);
};

// 保存用户信息
export const saveUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// 获取用户信息
export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

// 退出登录
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};